import React from 'react';
import { FaLinkedinIn, FaGithub } from 'react-icons/fa';
import { AiOutlineFileDone } from 'react-icons/ai';
import Pdf from '../data/Michael_Thompson_2022.pdf';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://github.com/thompsontnmt" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
    </div>
    <div>
      <a href="https://www.linkedin.com/in/mike-thompson-568309204/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
    </div>
    <div>
      <a href={Pdf} target="_blank" rel="noopener noreferrer"><AiOutlineFileDone/></a>
    </div>
  </div>
);

export default SocialMedia;